module.exports = __webpack_public_path__ + "img/banner-principal.a06b13f7.png";